import { ConfigurationParameters, Configuration, MailApi } from '../../openApi/ApiMail';

/**
 * Configuration
 */

export function buildMailRedux(configMail: ConfigurationParameters) {
    const mailConfiguration = new Configuration(configMail);

    const mailApi = new MailApi(mailConfiguration);

    return {
        serviceConfiguration: mailConfiguration,
        serviceConfigurationParameters: configMail,
        apis: {
            mailApi,
        },
        thunks: {},
        slices: {},
        fetchItems: {},
        getItems: {},
        models: {},
    };
}
